export default __webpack_public_path__ + "static/building-resilient-infrastructure-for-seamless-customer-service-delivery-e2fa58c9361435ccee9d7af8ee4030c8.png";